import MaterialComments from "./material-comments";
import MaterialContentCommentsLayout from "./material-content-comments-layout";
import {
  MaterialDateConfirmationMilestone,
  ProjectCalendarOffs
} from "./types";
import MaterialTimeline from "./timeline/material-timeline";

function MaterialTimelineSection({
  milestones,
  timezoneId,
  calendarOffs,
  comments,
  commentsDisabled = false,
  projectedDateLabel,
  forceFirstMilestoneReadOnly,
  canMarkCompleteWhenNoPrevious,
  disableFirstMilestoneSetActual,
  projectedDateErrorIds,
  actualDateErrorIds,
  onCommentsChange,
  onMilestoneChange,
  onMarkMilestoneComplete
}: {
  milestones: MaterialDateConfirmationMilestone[];
  timezoneId: string;
  calendarOffs?: ProjectCalendarOffs;
  comments?: string;
  commentsDisabled?: boolean;
  projectedDateLabel?: string;
  forceFirstMilestoneReadOnly?: boolean;
  canMarkCompleteWhenNoPrevious?: boolean;
  disableFirstMilestoneSetActual?: boolean;
  projectedDateErrorIds?: Set<string>;
  actualDateErrorIds?: Set<string>;
  onCommentsChange: (comments: string) => void;
  onMilestoneChange: (
    milestoneId: string,
    updates: Partial<
      Pick<MaterialDateConfirmationMilestone, "projectedDate" | "actualDate">
    >
  ) => void;
  onMarkMilestoneComplete: (milestoneId: string, isComplete: boolean) => void;
}) {
  return (
    <MaterialContentCommentsLayout
      testId="material-timeline-section"
      content={
        <>
          <div className="text-sm font-semibold text-color-1 mb-5">
            Timeline
          </div>
          <MaterialTimeline
            milestones={milestones}
            timezoneId={timezoneId}
            calendarOffs={calendarOffs}
            projectedDateLabel={projectedDateLabel}
            forceFirstMilestoneReadOnly={forceFirstMilestoneReadOnly}
            canMarkCompleteWhenNoPrevious={canMarkCompleteWhenNoPrevious}
            disableFirstMilestoneSetActual={disableFirstMilestoneSetActual}
            projectedDateErrorIds={projectedDateErrorIds}
            actualDateErrorIds={actualDateErrorIds}
            onMilestoneChange={onMilestoneChange}
            onMarkMilestoneComplete={onMarkMilestoneComplete}
          />
        </>
      }
      comments={
        <MaterialComments
          value={comments}
          disabled={commentsDisabled}
          onChange={onCommentsChange}
        />
      }
    />
  );
}

export default MaterialTimelineSection;
